/**
 * Big highlight teaser slider
 * @description: Highlight teaser slider with blaze-slider library to enable autoplay and draggable slides on mobile devices. We are using
 * the official 3rd party packages instead our blaze-slider package due to the lack of typescript support in this project.
 */
import BlazeSlider from "blaze-slider";
import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from "@elements/data-set-utils";

/**
 * Default selectors
 * @type {{base: string}}
 */
const defaultSelectors = {
    base: '.js-hero-slider',
    autoplayBtn: '.js-hero-slider__control-btn',
    autoplayActiveClass: 'hero-slider__control-btn--active'
};

/**
 * Default options
 * 3000 is the blaze slider default
 * @type {{autoplay: boolean}}
 * @type {{autoplayInterval: number}}
 */
const defaultOptions = {
    autoplay: false,
    autoplayInterval: 3000
};

/**
 * Initialize the highlight slider
 * @param {Object} options
 * @param {Object} selectors
 */
export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {

        options = {
            ...defaultOptions,
            ...options,
            ...getPrefixedDataSet('hero-slider', baseElement)
        };

        const slider = new BlazeSlider(baseElement, {
            all: {
                slidesToScroll: 1,
                enableAutoplay: options.autoplay,
                stopAutoplayOnInteraction: false,
                autoplayInterval: options.autoplayInterval,
                slidesToShow: 1,
                draggable: false
            },
            '(max-width: 767px)': {
                draggable: true,
                slideGap: '40px'
            }
        })

        if (options.autoplay) {
            const autoplayBtn = baseElement.querySelector(selectors.autoplayBtn);

            handleAutoplayBtnClick(autoplayBtn, slider)
        }

    });
}

/**
 * Handle autoplay start/stop on button click
 * @param {HTMLElement} autoplayBtn
 * @param {Object} slider
 */
const handleAutoplayBtnClick = (autoplayBtn, slider) => {
    let currentSlideIndex = 0

    autoplayBtn.addEventListener('click', () => {
        if (autoplayBtn.classList.contains(defaultSelectors.autoplayActiveClass)) {
            slider.stopAutoplay()
            currentSlideIndex = slider.stateIndex
            autoplayBtn.classList.remove(defaultSelectors.autoplayActiveClass)
        } else {
            const config = slider.config
            const dir = config.autoplayDirection === 'to left' ? 'next' : 'prev'

            slider.autoplayTimer = setInterval(() => {
                slider[dir]()
            }, config.autoplayInterval)

            autoplayBtn.classList.add(defaultSelectors.autoplayActiveClass)
        }
    })
}
